import { render, staticRenderFns } from "./DetailedWaybillReception.vue?vue&type=template&id=6ec4950e"
import script from "./DetailedWaybillReception.vue?vue&type=script&lang=js"
export * from "./DetailedWaybillReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports